import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Clock, Sparkles, Star, Webhook, type LucideIcon } from "lucide-react";
import {
  faHome, faCalendar, faUser, faUsers, faFilter, faExclamationTriangle,
  faBolt, faDownload, faCog, faChartLine,   faEnvelope, faEllipsis, faSearch,
  type IconDefinition,
} from "@fortawesome/free-solid-svg-icons";

// Outline icons matching the legacy menu (fa-star-o, fa-clock-o, mdi-webhook)
const OUTLINE_ICON_MAP: Record<string, LucideIcon> = {
  star: Star,
  clock: Clock,
  "network-wired": Webhook,
};

export const ICON_MAP: Record<string, IconDefinition> = {
  home: faHome,
  calendar: faCalendar,
  user: faUser,
  users: faUsers,
  filter: faFilter,
  "triangle-alert": faExclamationTriangle,
  zap: faBolt,
  download: faDownload,
  settings: faCog,
  "chart-line": faChartLine,
  envelope: faEnvelope,
  ellipsis: faEllipsis,
  search: faSearch,
};

export const MenuIcon = ({ name, className }: { name: string; className?: string }) => {
  if (name === "sparkles") {
    return (
      <span className="inline-flex w-[22px] shrink-0 items-center justify-center" aria-hidden>
        <Sparkles className={`size-[1.1em] ${className ?? ""}`} fill="currentColor" />
      </span>
    );
  }
  const Outline = OUTLINE_ICON_MAP[name];
  if (Outline) {
    return (
      <span className="inline-flex w-[22px] shrink-0 items-center justify-center" aria-hidden>
        <Outline className={`size-[1.15em] ${className ?? ""}`} strokeWidth={1.75} />
      </span>
    );
  }
  const icon = ICON_MAP[name];
  if (!icon) return null;
  return (
    <span className="inline-flex w-[22px] shrink-0 items-center justify-center" aria-hidden>
      <FontAwesomeIcon size="lg" icon={icon} className={className} aria-hidden />
    </span>
  );
}
